import { justDate } from './date-utils';

// U.S. Federal Holidays Calculator (matches your iOS app logic)
export function usFederalHolidays(year) {
  const holidays = [];

  // Fixed-date holidays with observed rules
  function addObservedHoliday(month, day, name) {
    const date = new Date(year, month - 1, day);
    const dayOfWeek = date.getDay();
    
    let observedDate = date;
    
    // If Saturday, observe on Friday
    if (dayOfWeek === 6) {
      observedDate = new Date(date);
      observedDate.setDate(date.getDate() - 1);
    }
    // If Sunday, observe on Monday
    else if (dayOfWeek === 0) {
      observedDate = new Date(date);
      observedDate.setDate(date.getDate() + 1);
    }
    
    holidays.push({
      name,
      date: justDate(observedDate)
    });
  }

  // Nth weekday of month (e.g., 3rd Monday of January)
  function nthWeekdayOfMonth(month, weekday, nth) {
    const date = new Date(year, month - 1, 1);
    
    // Find first occurrence of weekday
    while (date.getDay() !== weekday) {
      date.setDate(date.getDate() + 1);
    }
    
    // Add weeks to get to nth occurrence
    date.setDate(date.getDate() + (nth - 1) * 7);
    
    return justDate(date);
  }

  // Last weekday of month
  function lastWeekdayOfMonth(month, weekday) {
    const date = new Date(year, month, 0); // Last day of month
    
    // Go backwards until we find the weekday
    while (date.getDay() !== weekday) {
      date.setDate(date.getDate() - 1);
    }
    
    return justDate(date);
  }

  // New Year's Day
  addObservedHoliday(1, 1, "New Year's Day");

  // Martin Luther King Jr. Day (3rd Monday of January)
  holidays.push({
    name: "Martin Luther King Jr. Day",
    date: nthWeekdayOfMonth(1, 1, 3) // Monday = 1
  });

  // Presidents' Day (3rd Monday of February)
  holidays.push({
    name: "Presidents' Day",
    date: nthWeekdayOfMonth(2, 1, 3)
  });

  // Memorial Day (Last Monday of May)
  holidays.push({
    name: "Memorial Day",
    date: lastWeekdayOfMonth(5, 1)
  });

  // Juneteenth
  addObservedHoliday(6, 19, "Juneteenth");

  // Independence Day
  addObservedHoliday(7, 4, "Independence Day");

  // Labor Day (1st Monday of September)
  holidays.push({
    name: "Labor Day",
    date: nthWeekdayOfMonth(9, 1, 1)
  });

  // Columbus Day (2nd Monday of October)
  holidays.push({
    name: "Columbus Day",
    date: nthWeekdayOfMonth(10, 1, 2)
  });

  // Veterans Day
  addObservedHoliday(11, 11, "Veterans Day");

  // Thanksgiving (4th Thursday of November)
  holidays.push({
    name: "Thanksgiving",
    date: nthWeekdayOfMonth(11, 4, 4) // Thursday = 4
  });

  // Christmas
  addObservedHoliday(12, 25, "Christmas Day");

  return holidays;
}

// Get set of holiday dates for quick lookup
export function getHolidaySet(year) {
  const holidays = usFederalHolidays(year);
  return new Set(holidays.map(h => h.date.toISOString().slice(0, 10)));
}

// Check if date is a holiday
export function isHoliday(date) {
  const year = new Date(date).getFullYear();
  const holidaySet = getHolidaySet(year);
  const dateStr = justDate(date).toISOString().slice(0, 10);
  return holidaySet.has(dateStr);
}

// Get holiday name for a date (if any)
export function getHolidayName(date) {
  const year = new Date(date).getFullYear();
  const holidays = usFederalHolidays(year);
  const dateStr = justDate(date).toISOString().slice(0, 10);
  
  const holiday = holidays.find(h => 
    h.date.toISOString().slice(0, 10) === dateStr
  );
  
  return holiday?.name || null;
}